import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Events, Classes } from '../global/constants';


// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function () {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(fixed):not(.transition-clone)').each(function () {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if (image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- Header ----------

	$Elements.HeaderWrapper.each(function () {

		Animations.global.push(() => {

			if ($('body').hasClass('home')) {

				gsap.timeline({
					scrollTrigger: {
						start: 0,
						end: 'max',
						onUpdate: (self) => {
							self.direction === 1 ? this.classList.remove('shrink') : this.classList.add('shrink');
						}
					}
				});



				gsap.timeline({
					scrollTrigger: {
						start: 0,
						end: () => $('.content-section:first-child').height() + ($(this).height() * 2),
						toggleClass: {
							targets: this,
							className: 'force-shrink'
						}
					}
				});



				gsap.timeline({
					scrollTrigger: {
						start: () => ($('body').hasClass('home')) ? '50vh' : '5px',
						onEnter: () => $Elements.body.addClass('menu-light'),
						onLeaveBack: () => $Elements.body.removeClass('menu-light')
					}
				});



				Animations.global.push(() => {
					gsap.timeline({
						scrollTrigger: {
							start: 1,
							onEnter: () => $Elements.body.addClass('menu-light'),
							onLeaveBack: () => $Elements.body.removeClass('menu-light')
						}
					});
				});

			}

		});

		// ---------- Animated Introduction ----------

		$('.home-intro-section:not(.transition-clone)').each(function () {

			Animations.mobile.max.push(() => {

				gsap.from(".header-logo svg", {
					scrollTrigger: {
						scrub: true,
						start: '5px',
						end: "+=80%",
						//markers: true,
					},
					scale: 2,
					y: "50vh",
					ease: "none",
					yoyo: true,
					onStart: hideCTA,
					onReverseComplete: hideCTA,
				});
			});

			Animations.mobile.min.push(() => {

				gsap.from(".header-logo svg", {
					scrollTrigger: {
						scrub: true,
						start: '5px',
						end: "+=80%",
						//markers: true,
					},
					scale: 2.5,
					y: "50vh",
					ease: "none",
					yoyo: true,
					onStart: hideCTA,
					onReverseComplete: hideCTA,
				});
			});

			Animations.global.push(() => {
				gsap.timeline({
					scrollTrigger: {
						 scrub: true,
						 trigger: '.content-column.first-content',
						 start: "top 20%",
					//end: "100px",
					// markers: true,
						 toggleClass: {
								targets: '.header-wrapper',
								className: 'force-shrink2'
						 }
					}
			 });

				gsap.timeline({
					scrollTrigger: {
						pin: ".home-intro-section .image-column",
						start: 0,
						end: "+=200%",
					}
				});

				gsap.timeline(".home-intro-section .section-content", {
					scrollTrigger: {
						start: 5,
						end: "25vh",
						toggleClass: {
							targets: this,
							className: 'hide'
						}
					}
				});
			});
		});
	});
};


function displayMenu() {
	$('.header-wrapper').toggleClass('force-shrink2');
}

function hideCTA() {
	$('.first-section .section-content').toggleClass('hide');
}

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
